import { httpCreate } from './http';

const http = httpCreate('/srv/wxtp');

export const wxtp = {
	unAuth() {
		return http.delete('/live/unAuth');
	},
};
